module.exports = __webpack_public_path__ + "img/heisha.c0d85b41.png";